import Link from 'next/link'
import { Zap, MessageCircle } from 'lucide-react'
import { RevealWrapper } from '../components/RevealWrapper'

const SIGNUP_URL = '/auth/login'
const WHATSAPP_URL = 'https://wa.me/5532999107126?text=Gostaria%20de%20ter%20mais%20informa%C3%A7%C3%B5es%20sobre%20o%20DroneOps.'

export function FinalCTASection() {
  return (
    <section
      aria-label="Chamada para ação"
      style={{ padding: '0 16px 100px' }}
    >
      <RevealWrapper>
        <div
          style={{
            background: '#0B1D11',
            borderRadius: 28,
            padding: '52px 28px 44px',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
            maxWidth: 464,
            margin: '0 auto',
          }}
        >
          <div
            aria-hidden
            style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(ellipse 70% 50% at 50% 100%, rgba(58,140,86,0.22) 0%, transparent 70%)',
              pointerEvents: 'none',
            }}
          />

          <div style={{ position: 'relative', zIndex: 1 }}>
            <div
              style={{
                width: 52, height: 52,
                background: 'rgba(82,201,126,0.12)',
                borderRadius: 16,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 20px',
              }}
            >
              <Zap size={24} color="#52C97E" strokeWidth={1.8} />
            </div>

            <h2
              style={{
                fontFamily: 'var(--font-bricolage)',
                fontSize: 'clamp(24px, 7vw, 30px)',
                fontWeight: 800,
                color: '#fff',
                lineHeight: 1.18,
                letterSpacing: '-0.025em',
                marginBottom: 12,
              }}
            >
              Pronto para voar com
              <br />mais controle?
            </h2>

            <p
              style={{
                fontSize: 14,
                color: 'rgba(255,255,255,0.48)',
                lineHeight: 1.75,
                marginBottom: 32,
                maxWidth: 300,
                margin: '0 auto 32px',
              }}
            >
              Comece hoje. Configure em 10 minutos.
              Veja a diferença na primeira semana.
            </p>

            <Link
              href={SIGNUP_URL}
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                background: '#3A8C56',
                color: '#fff',
                padding: '16px 32px',
                borderRadius: 14,
                fontWeight: 700,
                fontSize: 15,
                fontFamily: 'var(--font-jakarta)',
                textDecoration: 'none',
                boxShadow: '0 4px 28px rgba(58,140,86,0.4)',
                marginBottom: 20,
              }}
            >
              Criar conta grátis →
            </Link>

            <div style={{ marginTop: 16 }}>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: 13,
                  color: 'rgba(255,255,255,0.35)',
                  textDecoration: 'none',
                }}
              >
                <MessageCircle size={14} strokeWidth={1.8} />
                Ainda tem dúvida? Respondo no WhatsApp.
              </a>
            </div>
          </div>
        </div>
      </RevealWrapper>
    </section>
  )
}
